{
	"showMore": "Show more ({{remainingElements}})",
	"showLess": "Show less"
}
